import { Injectable } from '@angular/core';
import { Label, LanguageService } from '@services/public';
import { toVoidPromise } from '@util';
import { uuid } from 'jakapa-utilities-lite';
import { Observable } from 'rxjs';
import { LeaderUserService, User } from '../user.service';

export interface OverallScoresColumn {
	name: string;
	value: number;
	label: string;
	users: Array<string>;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderReportOverallScoresService {
	// Page langauge.
	labels: { [key in Label]?: string } = {
		[Label.UNKNOWN_USER]: '',
		[Label.USERS]: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _userSvc: LeaderUserService,
	) {
		// Get page language.
		this._languageSvc.getLabels(this.labels);
	}

	async generateReport(
		data: Array<Array<uuid>>,
	): Promise<Array<OverallScoresColumn>> {
		// Get users list.
		let users: Array<User> = [];
		let apiCall: Observable<Array<User>> = this._userSvc.getUsers();
		apiCall.subscribe((res: Array<User>) => (users = res));
		await toVoidPromise(apiCall);

		return [
			{
				name: '1-2',
				value: data[0].length,
				label: `${data[0].length} ${this.labels[Label.USERS]}`,
				users: data[0].map(
					(uuid) =>
						users.find((user) => user.uuid === uuid)?.name ||
						this.labels[Label.UNKNOWN_USER],
				),
			},
			{
				name: '2-3',
				value: data[1].length,
				label: `${data[1].length} ${this.labels[Label.USERS]}`,
				users: data[1].map(
					(uuid) =>
						users.find((user) => user.uuid === uuid)?.name ||
						this.labels[Label.UNKNOWN_USER],
				),
			},
			{
				name: '3-4',
				value: data[2].length,
				label: `${data[2].length} ${this.labels[Label.USERS]}`,
				users: data[2].map(
					(uuid) =>
						users.find((user) => user.uuid === uuid)?.name ||
						this.labels[Label.UNKNOWN_USER],
				),
			},
			{
				name: '4-5',
				value: data[3].length,
				label: `${data[3].length} ${this.labels[Label.USERS]}`,
				users: data[3].map(
					(uuid) =>
						users.find((user) => user.uuid === uuid)?.name ||
						this.labels[Label.UNKNOWN_USER],
				),
			},
		];
	}
}
